<template>
  <div
    class="slds-var-p-around_small slds-grid slds-grid_align-center"
    v-if="$auth.isAuthenticated"
  >
    <div class="slds-col slds-size_4-of-6">
      <div class="vld-parent">
        <loading
          :active.sync="isLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="fullPage"
        ></loading>
      </div>
      <div class="slds-page-header slds-page-header_record-home">
        <div class="slds-page-header__row">
          <div class="slds-page-header__col-title">
            <div class="slds-media">
              <div class="slds-media__figure">
                <span
                  class="slds-icon_container slds-icon-standard-opportunity"
                >
                  <svg
                    class="slds-icon slds-page-header__icon"
                    aria-hidden="true"
                  >
                    <use
                      xlink:href="/assets/icons/custom-sprite/svg/symbols.svg#custom102"
                    ></use>
                  </svg>
                </span>
              </div>
              <div class="slds-media__body">
                <div class="slds-page-header__name">
                  <div class="slds-page-header__name-title">
                    <h1>
                      <span></span>
                      <span
                        class="slds-page-header__title slds-truncate"
                        title="Analysis"
                        >Analysis Filters</span
                      >
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slds-page-header__col-actions">
            <div class="slds-page-header__controls">
              <div class="slds-page-header__control">
                <ul class="slds-button-group-list">
                  <li>
                    <button
                      variant="primary"
                      class="slds-button slds-button_neutral"
                      v-on:click="resetFilters()"
                    >
                      Reset Filters
                    </button>
                  </li>
                  <li>
                    <router-link
                      :to="{
                        name: 'CampaignReport',
                        params: {
                          filter: this.selectedFilter,
                          selectedOptions: this.selectedOptions,
                          IsFromSegments: false,
                          campIdsArr: this.campIdsArr,
                        },
                      }"
                    >
                      <button
                        variant="primary"
                        class="slds-button slds-button_brand"
                      >
                        Search
                      </button>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article class="slds-card slds-m-top_large">
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span>Package Attributes</span>
              </h2>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="carrierpostagetype"
                    >Carrier Postage Type
                  </label>
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.carrierPostageType"
                        name="POSTAGE_TYPE"
                        data-label="Postage Type"
                        id="carrierpostagetype"
                      >
                        <option
                          v-for="carrierPostage in carrierPostageType"
                          v-bind:key="carrierPostage.lookUpValueCode"
                          v-bind:value="carrierPostage.lookUpValueText"
                          >{{ carrierPostage.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="carriersize"
                    >Carrier Size</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.carrierSize"
                        name="CARRIER_SIZE"
                        data-label="Carrier Size"
                        id="carriersize"
                      >
                        <option
                          v-for="carrierSize in carrierSizes"
                          v-bind:key="carrierSize.lookUpValueCode"
                          v-bind:value="carrierSize.lookUpValueText"
                          >{{ carrierSize.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="replypostagetype"
                    >Reply Postage Type
                  </label>
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.replyPostageType"
                        name="REPLY_POSTAGE_TYPE"
                        data-label="Reply Postage Type"
                        id="replypostagetype"
                      >
                        <option
                          v-for="replyPostageType in replyPostageTypes"
                          v-bind:key="replyPostageType.lookUpValueCode"
                          v-bind:value="replyPostageType.lookUpValueText"
                          >{{ replyPostageType.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="doublesidedprinting"
                    >Double Sided Printing</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.doubleSidedPrinting"
                        name="DOUBLESIDEDPRINTING"
                        data-label="Double Sided Printing"
                        id="doublesidedprinting"
                      >
                        <option
                          v-for="doubleSidedPrinting in doubleSidedPrintings"
                          v-bind:key="doubleSidedPrinting.lookUpValueCode"
                          v-bind:value="doubleSidedPrinting.lookUpValueText"
                          >{{ doubleSidedPrinting.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="signer"
                    >Signer
                  </label>
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.signer"
                        name="SIGNER"
                        data-label="Signer"
                        id="signer"
                      >
                        <option
                          v-for="signer in signers"
                          v-bind:key="signer.lookUpValueCode"
                          v-bind:value="signer.lookUpValueText"
                          >{{ signer.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="channel"
                    >Channel</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.channel"
                        name="CHANNEL"
                        data-label="Channel"
                        id="channel"
                      >
                        <option
                          v-for="channel in channels"
                          v-bind:key="channel.lookUpValueCode"
                          v-bind:value="channel.lookUpValueText"
                          >{{ channel.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <Lookup
                  :htmlId="`purpose`"
                  :label="`Purpose`"
                  :options="purposes"
                  @columnsSelected="
                    setFilterForMultiSelect(
                      $event,
                      `selectedOptions.purposeSelected`,
                      `selectedOptions.purposeFilter`,
                      'PURPOSE',
                      'Purpose'
                    )
                  "
                  :selectedColumns="selectedOptions.purpose"
                />
              </div>
              <div class="slds-form__item" role="listitem">
                <Lookup
                  :htmlId="`detailchannel`"
                  :label="`Detail Channel`"
                  :options="detailChannels"
                  @columnsSelected="
                    setFilterForMultiSelect(
                      $event,
                      `selectedOptions.detailChannelSelected`,
                      `selectedOptions.detailChannelFilter`,
                      'DETAIL_CHANNEL',
                      'Detail Channel'
                    )
                  "
                  :selectedColumns="selectedOptions.detailChannel"
                />
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="slds-card">
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span>Campaign Details</span>
              </h2>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="appealStartDate"
                    >Campaign Start Date</label
                  >
                  <div class="slds-form-element__control slds-input-has-icon">
                    <input
                      class="slds-input"
                      type="date"
                      v-model="selectedOptions.startDate"
                      @change="setFilter($event)"
                      name="APPEALSTARTDATE"
                      data-label="Campaign Start Date"
                      id="appealStartDate"
                    />
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="appealEndDate"
                    >Campaign End Date
                  </label>
                  <div class="slds-form-element__control slds-input-has-icon">
                    <input
                      class="slds-input"
                      type="date"
                      v-model="selectedOptions.endDate"
                      @change="setFilter($event)"
                      name="APPEALENDDATE"
                      data-label="Campaign End Date"
                      id="appealEndDate"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="appealIdFrom"
                    >Campaign Names</label
                  >
                  <div class="slds-form-element__control">
                    <textarea
                      class="slds-textarea"
                      id="campaignIds"
                      v-model="selectedOptions.campaignIds"
                      @change="setFilter($event)"
                      rows="6"
                      cols="50"
                      data-label="Campaign Names"
                      name="CAMPAIGNIDS"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="appealIdLike"
                    >Campaign ID Like</label
                  >
                  <div class="slds-form-element__control">
                    <input
                      class="slds-input"
                      type="text"
                      v-model="selectedOptions.appealIdLike"
                      @change="setFilter($event)"
                      name="APPEALIDLIKE"
                      data-label="Campaign ID Like"
                      id="appealIdLike"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="slds-card">
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span>Gift Details</span>
              </h2>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="giftChannel"
                    >Gift Channel</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.giftChannel"
                        id="giftChannel"
                        data-label="Gift Channel"
                        name="GIFT_CHANNEL"
                      >
                        <option
                          v-for="giftChannel in giftChannels"
                          v-bind:key="giftChannel.lookUpValueCode"
                          v-bind:value="giftChannel.lookUpValueText"
                          >{{ giftChannel.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <Lookup
                  :htmlId="`donor`"
                  :label="`Donor`"
                  :options="donors"
                  @columnsSelected="
                    setFilterForMultiSelect(
                      $event,
                      `selectedOptions.donorSelected`,
                      `selectedOptions.donorFilter`,
                      'DONORS',
                      'Donors'
                    )
                  "
                  :selectedColumns="selectedOptions.donor"
                />
              </div>
            </div>
          </div>
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="initialGiftSizeGreater"
                    >Gift Size</label
                  >
                  <div
                    class="slds-form-element__control slds-input-has-fixed-addon"
                  >
                    <span
                      class="slds-form-element__addon"
                      id="fixed-text-addon-pre"
                      >&gt;=</span
                    >
                    <input
                      class="slds-input"
                      v-model="selectedOptions.initialGiftSizeGreater"
                      type="Number"
                      min="0"
                      step="0.01"
                      @change="setFilter($event)"
                      name="INITIALGIFTSIZEGREATER"
                      data-label="Initial Gift Size Greater (>=)"
                      id="initialGiftSizeGreater"
                    />
                  </div>
                  <div
                    class="slds-p-top_small slds-form-element__control slds-input-has-fixed-addon"
                  >
                    <span
                      class="slds-form-element__addon"
                      id="fixed-text-addon-pre"
                      >&lt;=</span
                    >
                    <input
                      class="slds-input"
                      v-model="selectedOptions.initialGiftSizeLess"
                      type="Number"
                      min="0"
                      step="0.01"
                      @change="setFilter($event)"
                      name="INITIALGIFTSIZELESS"
                      data-label="Initial Gift Size Less (<=)"
                      id="initialGiftSizeLess"
                    />
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="giftDateGreater"
                    >Gift Date</label
                  >
                  <div
                    class="slds-form-element__control slds-input-has-fixed-addon slds-input-has-icon"
                  >
                    <span
                      class="slds-form-element__addon"
                      id="fixed-text-addon-pre"
                      >&gt;=</span
                    >
                    <input
                      v-model="selectedOptions.initialGiftFromDate"
                      class="slds-input"
                      type="date"
                      @change="setFilter($event)"
                      name="INITIALGIFTRANGEGREATER"
                      data-label="Inital Gift Range Greater (>=)"
                      id="giftDateGreater"
                    />
                  </div>
                  <div
                    class="slds-p-top_small slds-form-element__control slds-input-has-fixed-addon slds-input-has-icon"
                  >
                    <span
                      class="slds-form-element__addon"
                      id="fixed-text-addon-pre"
                      >&lt;=</span
                    >
                    <input
                      v-model="selectedOptions.initialGiftToDate"
                      class="slds-input"
                      placeholder="<="
                      type="date"
                      @change="setFilter($event)"
                      name="INITIALGIFTRANGELESS"
                      data-label="Initial Gift Range Less (<=)"
                      id="giftDateLess"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="utmCampaign"
                    >UTM Campaign</label
                  >
                  <div class="slds-form-element__control">
                    <input
                      class="slds-input"
                      type="text"
                      v-model="selectedOptions.utmCampaign"
                      @change="setFilter($event)"
                      name="UTMCAMPAIGN"
                      data-label="UTM Campaign"
                      id="utmCampaign"
                    />
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="utmContent"
                    >UTM Content</label
                  >
                  <div class="slds-form-element__control">
                    <input
                      class="slds-input"
                      type="text"
                      v-model="selectedOptions.utmContent"
                      @change="setFilter($event)"
                      name="UTMCONTENT"
                      data-label="UTM Content"
                      id="utmContent"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="utmMedium"
                    >UTM Medium
                  </label>
                  <div class="slds-form-element__control">
                    <input
                      class="slds-input"
                      type="text"
                      v-model="selectedOptions.utmMedium"
                      @change="setFilter($event)"
                      name="UTMMEDIUM"
                      data-label="UTM Medium"
                      id="utmMedium"
                    />
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="utmSource"
                    >UTM Source</label
                  >
                  <div class="slds-form-element__control">
                    <input
                      class="slds-input"
                      type="text"
                      v-model="selectedOptions.utmSource"
                      @change="setFilter($event)"
                      name="UTMSOURCE"
                      data-label="UTM Source"
                      id="utmSource"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      <article class="slds-card">
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span>Subsequent Giving</span>
              </h2>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <div class="slds-form-element__control">
                    <div class="slds-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectedOptions.isSubsequentAnalysis"
                        @change="
                          toggleFlag('isSubsequentAnalysisParam', $event)
                        "
                        name="SUBSEQUENTANALYSIS"
                        data-label="Subsequent Analysis"
                        id="subsequentanalysis"
                      />
                      <label
                        class="slds-checkbox__label"
                        for="subsequentanalysis"
                      >
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label"
                          >Subsequent Analysis</span
                        >
                      </label>
                    </div>
                  </div>
                </div>
                <div class="slds-form-element slds-form-element_stacked">
                  <div class="slds-form-element__control">
                    <div class="slds-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectedOptions.isSubsequentChannelAnalysis"
                        @change="
                          toggleFlag('isSubsequentChannelAnalysisParam', $event)
                        "
                        name="SUBSEQUENT_CHANNEL_ANALYSIS"
                        data-label="Subsequent Channel Analysis"
                        id="subsequentchannelanalysis"
                      />
                      <label
                        class="slds-checkbox__label"
                        for="subsequentchannelanalysis"
                      >
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label"
                          >Subsequent Channel Analysis</span
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <fieldset class="slds-form-element slds-form-element_compound">
                  <div class="slds-form-element__control">
                    <div class="slds-form-element__row">
                      <div class="slds-size_1-of-2">
                        <div class="slds-form-element">
                          <label
                            class="slds-form-element__label slds-no-flex"
                            for="subsequentGiftStartDate"
                            >Gift Start Date</label
                          >
                          <div
                            class="slds-form-element__control slds-input-has-icon"
                          >
                            <input
                              class="slds-input"
                              type="date"
                              v-model="
                                selectedOptions.subsequentGivingStartDate
                              "
                              @change="setFilter($event)"
                              name="SUBSEQUENT_GIFT_STARTDATE"
                              data-label="Subsequent Gift Start Date"
                              id="subsequentGiftStartDate"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="slds-size_1-of-2">
                        <div class="slds-form-element">
                          <label
                            class="slds-form-element__label slds-no-flex"
                            for="subsequentGiftEndDate"
                            >Gift End Date</label
                          >
                          <div
                            class="slds-form-element__control slds-input-has-icon"
                          >
                            <input
                              class="slds-input"
                              type="date"
                              v-model="selectedOptions.subsequentGivingEndDate"
                              @change="setFilter($event)"
                              name="SUBSEQUENT_GIFT_ENDDATE"
                              data-label="Subsequent Gift End Date"
                              id="subsequentGiftEndDate"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="subsequentGiftChannel"
                    >Gift Channel</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.subsequentGiftChannel"
                        id="subsequentGiftChannel"
                        data-label="Subsequent Gift Channel"
                        name="SUBSEQUENT_GIFT_CHANNEL"
                      >
                        <option
                          v-for="giftChannel in subsequentGiftChannels"
                          v-bind:key="giftChannel.lookUpValueCode"
                          v-bind:value="giftChannel.lookUpValueText"
                          >{{ giftChannel.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="subsequentGiftDetailChannel"
                    >Gift Detail Channel</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.subsequentGiftDetailChannel"
                        id="subsequentGiftDetailChannel"
                        data-label="Subsequent Gift Detail Channel"
                        name="SUBSEQUENT_GIFT_DETAIL_CHANNEL"
                      >
                        <option
                          v-for="detailChannel in subsequentGiftDetailChannels"
                          v-bind:key="detailChannel.lookUpValueCode"
                          v-bind:value="detailChannel.lookUpValueText"
                          >{{ detailChannel.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="subsequentGiftPurpose"
                    >Gift Purpose</label
                  >
                  <div class="slds-form-element__control">
                    <div class="slds-select_container">
                      <select
                        class="slds-select"
                        @change="setFilter($event)"
                        v-model="selectedOptions.subsequentGiftPurpose"
                        id="subsequentGiftPurpose"
                        data-label="Subsequent Gift Purpose"
                        name="SUBSEQUENT_GIFT_PURPOSE"
                      >
                        <option
                          v-for="purpose in subsequentGiftPurposes"
                          v-bind:key="purpose.lookUpValueCode"
                          v-bind:value="purpose.lookUpValueText"
                          >{{ purpose.lookUpValueText }}</option
                        >
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!--Added -->
      <article class="slds-card">
        <div class="slds-card__header slds-grid">
          <header class="slds-media slds-media_center slds-has-flexi-truncate">
            <div class="slds-media__body">
              <h2 class="slds-card__header-title">
                <span>Options and Filters</span>
              </h2>
            </div>
          </header>
        </div>
        <div class="slds-card__body slds-card__body_inner">
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <Lookup
                  :htmlId="`groupBy`"
                  :label="`Group Rows`"
                  :options="subtotalByList"
                  @columnsSelected="
                    setFilterForMultiSelect(
                      $event,
                      `selectedOptions.subtotalBySelected`,
                      `selectedOptions.subTotalFilter`,
                      'SUBTOTAL_BY',
                      'Group By'
                    )
                  "
                  :selectedColumns="selectedOptions.subtotalBy"
                  :limit="3"
                />
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <label
                    class="slds-form-element__label slds-no-flex"
                    for="movie"
                    >Estimate Cost</label
                  >
                  <div class="slds-form-element__control slds-input-has-icon">
                    <currency-input
                      v-model="selectedOptions.estimatecost"
                      currency="USD"
                      class="slds-input"
                      @change="setFilterForEstimate($event)"
                      data-label="Estimate Cost"
                      name="ESTIMATECOST"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <div class="slds-form-element__control">
                    <div class="slds-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectedOptions.isUpgradeAnalysis"
                        @change="toggleFlag('isUpgradeAnalysis', $event)"
                        name="UPGRADEANALYSIS"
                        data-label="Upgrade Analysis"
                        id="upgradeanalysis"
                      />
                      <label class="slds-checkbox__label" for="upgradeanalysis">
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label"
                          >Upgrade Analysis</span
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <div class="slds-form-element__control">
                    <div class="slds-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectedOptions.isEmailAnalysis"
                        @change="toggleFlag('isEmailAnalysis', $event)"
                        name="EMAILANALYSIS"
                        data-label="Email Analysis"
                        id="emailanalysis"
                      />
                      <label class="slds-checkbox__label" for="emailanalysis">
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label"
                          >Email Analysis</span
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="slds-form" role="list">
            <div class="slds-form__row">
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <div class="slds-form-element__control">
                    <div class="slds-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectedOptions.isPercentColumns"
                        @change="toggleFlag('isPercentColumns', $event)"
                        name="PERCENT_COLUMNS"
                        data-label="Percent Columns"
                        id="percentcolumns"
                      />
                      <label class="slds-checkbox__label" for="percentcolumns">
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label"
                          >Show Percentage Columns</span
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="slds-form__item" role="listitem">
                <div class="slds-form-element slds-form-element_stacked">
                  <div class="slds-form-element__control">
                    <div class="slds-checkbox">
                      <input
                        type="checkbox"
                        v-model="selectedOptions.excludeInTotals"
                        @change="toggleFlag('excludeInTotals', $event)"
                        name="INCLUDE_IN_TOTALS"
                        data-label="Exclude Campaigns Without Expenses in Totals"
                        id="includetotals"
                      />
                      <label class="slds-checkbox__label" for="includetotals">
                        <span class="slds-checkbox_faux"></span>
                        <span class="slds-form-element__label"
                          >Exclude Campaigns Without Expenses in Totals</span
                        >
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
      <!--Ended-->
    </div>
  </div>
</template>
<script>
import { getLookUpValuesByCodeUrl } from "../config";
import ApiService from "../service/apiService";
import operatorFn from "../mixins/operators";

// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

let dateFullYear = new Date().getFullYear();
const appealStartDate = dateFullYear + "-01-01";
const appealEndDate = dateFullYear + "-12-31";
const ALL_STRING = "All";
const LOOKUP_CONFIG = new Map([
  ["carrierPostageType", "POSTAGE_TYPE"],
  ["channels", "CHANNEL"],
  ["carrierSizes", "CARRIER_SIZE"],
  ["replyPostageTypes", "REPLY_POSTAGE_TYPE"],
  ["signers", "SIGNER"],
  ["purposes", "PURPOSE"],
  ["subsequentGiftPurposes", "PURPOSE"],
  ["detailChannels", "DETAIL_CHANNEL"],
  ["subsequentGiftDetailChannels", "DETAIL_CHANNEL"],
  ["types", "TYPE"],
  ["giftChannels", "GIFT_CHANNEL"],
  ["subsequentGiftChannels", "GIFT_CHANNEL"],
  ["sortByList", "SORT_BY"],
  ["subtotalByList", "SUBTOTAL_BY"],
  ["donors", "DONORS"],
  ["doubleSidedPrintings", "DOUBLESIDEDPRINTING"],
]);
const SELECTED_VALUE_CONFIG = new Map([
  [
    "POSTAGE_TYPE",
    { selectedVar: "carrierPostageType", valueType: "filterTypeText" },
  ],
  ["CHANNEL", { selectedVar: "channel", valueType: "filterTypeText" }],
  ["CARRIER_SIZE", { selectedVar: "carrierSize", valueType: "filterTypeText" }],
  [
    "REPLY_POSTAGE_TYPE",
    { selectedVar: "replyPostageType", valueType: "filterTypeText" },
  ],
  ["SIGNER", { selectedVar: "signer", valueType: "filterTypeText" }],
  ["PURPOSE", { selectedVar: "purposeFilter", valueType: "filterTypeText" }],
  [
    "DETAIL_CHANNEL",
    { selectedVar: "detailChannelFilter", valueType: "filterTypeText" },
  ],
  ["TYPE", { selectedVar: "type", valueType: "filterTypeText" }],
  ["GIFT_CHANNEL", { selectedVar: "giftChannel", valueType: "filterTypeText" }],
  ["SORT_BY", { selectedVar: "sortBy", valueType: "filterTypeText" }],
  [
    "SUBTOTAL_BY",
    { selectedVar: "subTotalFilter", valueType: "filterTypeText" },
  ],
  [
    "APPEALSTARTDATE",
    { selectedVar: "startDate", valueType: "filterTypeText" },
  ],
  ["APPEALENDDATE", { selectedVar: "endDate", valueType: "filterTypeText" }],
  [
    "SUBSEQUENT_GIFT_STARTDATE",
    { selectedVar: "subsequentGivingStartDate", valueType: "filterTypeText" },
  ],
  [
    "SUBSEQUENT_GIFT_ENDDATE",
    { selectedVar: "subsequentGivingEndDate", valueType: "filterTypeText" },
  ],
  [
    "SUBSEQUENT_GIFT_CHANNEL",
    { selectedVar: "subsequentGiftChannel", valueType: "filterTypeText" },
  ],
  [
    "SUBSEQUENT_GIFT_DETAIL_CHANNEL",
    { selectedVar: "subsequentGiftDetailChannel", valueType: "filterTypeText" },
  ],
  [
    "SUBSEQUENT_GIFT_PURPOSE",
    { selectedVar: "subsequentGiftPurpose", valueType: "filterTypeText" },
  ],
  [
    "DOUBLESIDEDPRINTING",
    { selectedVar: "doubleSidedPrinting", valueType: "filterTypeText" },
  ],
  [
    "APPEALIDLIKE",
    { selectedVar: "appealIdLike", valueType: "filterTypeText" },
  ],
  [
    "INITIALGIFTSIZEGREATER",
    { selectedVar: "initialGiftSizeGreater", valueType: "filterTypeText" },
  ],
  [
    "INITIALGIFTSIZELESS",
    { selectedVar: "initialGiftSizeLess", valueType: "filterTypeText" },
  ],
  [
    "INITIALGIFTRANGEGREATER",
    { selectedVar: "initialGiftFromDate", valueType: "filterTypeText" },
  ],
  [
    "INITIALGIFTRANGELESS",
    { selectedVar: "initialGiftToDate", valueType: "filterTypeText" },
  ],
  [
    "ESTIMATECOST",
    { selectedVar: "estimatecost", valueType: "filterTypeText" },
  ],
  ["UTMCAMPAIGN", { selectedVar: "utmCampaign", valueType: "filterTypeText" }],
  ["UTMCONTENT", { selectedVar: "utmContent", valueType: "filterTypeText" }],
  ["UTMMEDIUM", { selectedVar: "utmMedium", valueType: "filterTypeText" }],
  ["UTMSOURCE", { selectedVar: "utmSource", valueType: "filterTypeText" }],
  ["DONORS", { selectedVar: "donorFilter", valueType: "filterTypeText" }],
  [
    "UPGRADEANALYSIS",
    { selectedVar: "isUpgradeAnalysis", valueType: "filterTypeText" },
  ],
  [
    "EMAILANALYSIS",
    { selectedVar: "isEmailAnalysis", valueType: "filterTypeText" },
  ],
  [
    "SUBSEQUENTANALYSIS",
    { selectedVar: "isSubsequentAnalysis", valueType: "filterTypeText" },
  ],
  [
    "SUBSEQUENT_CHANNEL_ANALYSIS",
    { selectedVar: "isSubsequentChannelAnalysis", valueType: "filterTypeText" },
  ],
  [
    "PERCENT_COLUMNS",
    { selectedVar: "isPercentColumns", valueType: "filterTypeText" },
  ],
  [
    "INCLUDE_IN_TOTALS",
    { selectedVar: "excludeInTotals", valueType: "filterTypeText" },
  ],
  [
    "CAMPAIGNIDS",
    {
      selectedVar: "campaignIds",
      valueType: "filterTypeArray",
      joinKey: "\r\n",
    },
  ],
]);
export default {
  name: "CampaignAnalysis",
  mixins: [operatorFn],
  data() {
    return {
      carrierPostageType: [],
      selectedOptions: {},
      channels: [],
      carrierSizes: [],
      replyPostageTypes: [],
      signers: [],
      purposes: [],
      detailChannels: [],
      types: [],
      giftChannels: [],
      sortByList: [],
      subtotalByList: [],
      selectedFilter: [],
      doubleSidedPrintings: [],
      isLoading: false,
      fullPage: true,
      subsequentGiftChannels: [],
      subsequentGiftDetailChannels: [],
      subsequentGiftPurposes: [],
      campIdsArr: {},
      donors: [],
    };
  },
  components: {
    Loading: () => import("vue-loading-overlay"),
    Lookup: () => import("./Lookup.vue"),
  },
  created: function() {
    LOOKUP_CONFIG.forEach((type, lookupVar) => this.getLookup(lookupVar, type));

    this.setDefaults();
    this.selectedOptions = {
      ...this.selectedOptions,
      ...this.$route.params.selectedOptions,
    };

    if (this.$route.params.filter != undefined) {
      this.$route.params.filter.forEach((el) => {
        let config = SELECTED_VALUE_CONFIG.get(el.filterTypeCode);
        this.selectedOptions[config.selectedVar] = el[config.valueType];
        if (config.valueType == "filterTypeArray") {
          this.selectedOptions[config.selectedVar] = this.selectedOptions[
            config.selectedVar
          ].join(config.joinKey);
        }
      });

      this.selectedFilter = this.$route.params.filter;
      this.isLoading = false;
    }

    if (this.$route.params.selectedOptions) {
      if (!this.$route.params.selectedOptions.startDate) {
        this.selectedOptions.startDate = "";
        this.selectedFilter = this.selectedFilter.filter(
          (fltr) => fltr.filterTypeCode != "APPEALSTARTDATE"
        );
      }

      if (!this.$route.params.selectedOptions.endDate) {
        this.selectedOptions.endDate = "";
        this.selectedFilter = this.selectedFilter.filter(
          (fltr) => fltr.filterTypeCode != "APPEALENDDATE"
        );
      }
    }
  },
  methods: {
    setDefaults: function() {
      this.selectedOptions = {
        carrierPostageType: ALL_STRING,
        channel: ALL_STRING,
        carrierSize: ALL_STRING,
        replyPostageType: ALL_STRING,
        signer: ALL_STRING,
        type: ALL_STRING,
        giftChannel: ALL_STRING,
        sortBy: "",
        doubleSidedPrinting: ALL_STRING,
        startDate: appealStartDate,
        endDate: appealEndDate,
        subsequentGivingStartDate: "",
        subsequentGivingEndDate: "",
        subsequentGiftChannel: ALL_STRING,
        subsequentGiftDetailChannel: ALL_STRING,
        subsequentGiftPurpose: ALL_STRING,
        appealIdLike: "",
        initialGiftSizeGreater: "",
        initialGiftSizeLess: "",
        initialGiftFromDate: "",
        initialGiftToDate: "",
        utmContent: "",
        utmCampaign: "",
        utmMedium: "",
        utmSource: "",
        isUpgradeAnalysis: false,
        isEmailAnalysis: false,
        isSubsequentAnalysis: false,
        isSubsequentChannelAnalysis: false,
        isPercentColumns: false,
        excludeInTotals: false,
        estimatecost: 0,
        campaignIds: "",

        /* Multi-Select options */
        subTotalFilter: "",
        subtotalBy: [],

        purposeFilter: "",
        purpose: [],

        detailChannelFilter: "",
        detailChannel: [],

        donorFilter: "",
        donor: [],
      };

      this.selectedFilter = [
        {
          filterTypeCode: "APPEALSTARTDATE",
          filterTypeText: this.selectedOptions.startDate,
          filterTypeLabel: "Campaign Start Date",
        },
        {
          filterTypeCode: "APPEALENDDATE",
          filterTypeText: this.selectedOptions.endDate,
          filterTypeLabel: "Campaign End Date",
        },
      ];
    },
    resetFilters: function() {
      this.$route.params.filter = [];
      this.setDefaults();
    },
    setFilter(event) {
      let foundIndex = this.selectedFilter.findIndex(
        (el) => el.filterTypeCode == event.target.name
      );

      if (foundIndex > -1) {
        this.selectedFilter.splice(foundIndex, 1);
      }

      if (event.target.name == "CAMPAIGNIDS") {
        var campaignIdsLists = event.target.value.split(/\r?\n/);
        this.selectedFilter.push({
          filterTypeCode: event.target.name,
          filterTypeArray: campaignIdsLists,
          filterTypeLabel: event.target.dataset.label,
        });
      } else if (
        ![
          "UPGRADEANALYSIS",
          "EMAILANALYSIS",
          "SUBSEQUENTANALYSIS",
          "SUBSEQUENT_CHANNEL_ANALYSIS",
          "PERCENT_COLUMNS",
          "INCLUDE_IN_TOTALS",
        ].includes(event.target.name) ||
        event.target.checked
      ) {
        this.selectedFilter.push({
          filterTypeCode: event.target.name,
          filterTypeText: event.target.value,
          filterTypeLabel: event.target.dataset.label,
        });
      }
    },
    setFilterForEstimate: function(ev) {
      var foundIndex = this.findIndex(
        this.selectedFilter,
        "filterTypeCode",
        "ESTIMATECOST"
      );
      if (foundIndex > -1) {
        this.selectedFilter.splice(foundIndex, 1);
      }

      if (ev) {
        this.selectedFilter.push({
          filterTypeCode: "ESTIMATECOST",
          filterTypeText: ev,
          filterTypeLabel: "Estimate Cost",
        });
      }
    },
    setFilterForMultiSelect: function(
      ev,
      selectedVar,
      filterVar,
      typeCode,
      typeLabel
    ) {
      this[selectedVar] = ev;
      /*
					we are reducing the filter to one node with values as an array
					additionally, we are breaking down the List/Select option and 
					thus flattening the array
				*/
      this[filterVar] = this[selectedVar]
        .map((el) => el.lookUpValueCode)
        .join(",");
      var foundIndex = this.findIndex(
        this.selectedFilter,
        "filterTypeCode",
        typeCode
      );
      if (foundIndex > -1) {
        this.selectedFilter.splice(foundIndex, 1);
      }
      if (this[filterVar]) {
        this.selectedFilter.push({
          filterTypeCode: typeCode,
          filterTypeText: this[filterVar],
          filterTypeLabel: typeLabel,
        });
      }
    },
    getLookup: async function(lookupVar, type) {
      ApiService.getMetadata(`${getLookUpValuesByCodeUrl}${type}`, true)
        .then((response) => (this[lookupVar] = response.data))
        .catch((error) => console.log(error));
    },
    onCancel() {
      console.log("User cancelled the loader.");
    },
    toggleFlag: function(flagName, event) {
      this[flagName] = event.target.checked;
      this.setFilter(event);
    },
  },
};
</script>
<style scoped>
textarea {
  resize: none;
}
</style>
